// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZhZ8","rootNoMargin":"styles_rootNoMargin__1fgDa"};